module.exports = __webpack_public_path__ + "img/logo.a6ca4af7.svg";